import TealSidebarRightModernThumbnailPath from '../../../assets/template-thumbnails/sidebar-right/teal-modern-sidebar-right-template-thumbnail.png';

const TealSidebarRightModernTemplate = {
    id: 'teal-modern-sidebar-right-template',
    name: 'Teal Modern',
    category: 'Sidebar Right Modern',
    settings: {
      layoutId: 'sidebar-right',
      designId: 'custom',
      style: 'tech',
      background: 'blank',
      barStyleId: 'bars',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#009688",
        secondary: "#004D40",
        tertiary: "#26A69A",
        quaternary: "#00695C",
        accent1: "#80CBC4",
        accent2: "#4DB6AC",
        accent3: "#26A69A",
        accent4: "#00897B",
        accent5: "#00796B",
        accent6: "#00695C",
        accent7: "#B2DFDB",
        accent8: "#FFFFFF",
        text: "#004D40",
        textSecondary: "#00695C",
        background: "#FFFFFF",
        sidebarBackground: "rgba(0, 150, 136, 1)",
        border: "rgba(0, 150, 136, 1)",
        sidebarPrimary: "rgba(255, 255, 255, 1)",
        sidebarText: "rgba(255, 255, 255, 1)"
      },
      typography: {
        cvTitle: { fontSize: 24, lineHeight: 1.4, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 12, lineHeight: 1.2, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 10, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: TealSidebarRightModernThumbnailPath
  };

export default TealSidebarRightModernTemplate; 